import React from 'react';
import styles from './Onboarding.module.css';
import * as utils from '../../utils/utils';
import HQDialog from '../HQDialog/HQDialog';
import OnboardingNickname from './OnboardingNickname/OnboardingNickname';
import OnboardingResume from './OnboardingResume/OnboardingResume';
import OnboardingAvailability from './OnboardingAvailability/OnboardingAvailability';
import OnboardingOffers from './OnboardingOffers/OnboardingOffers';
import HQStreamerUtil from '../HQStreamerUtil/HQStreamerUtil';
import { FiHeart, FiLoader, FiAlignJustify, FiBook, FiBookOpen, FiBriefcase, FiAward, FiZap, FiBox, FiThumbsUp } from 'react-icons/fi';

export default class Onboarding extends React.Component {

    constructor(props) {
        super(props);

        this.screens = {
            Intro: 10,
            Resume: 20,
            Nickname: 30,
            Availability: 40,
            Offers: 50,
            FinishingUp: 60,
        };

        this.nicknameLayoutShellDialogHost = null;
        this.resumeLayoutShellDialogHost = null;
        this.availabilityLayoutShellDialogHost = null;
        this.offersLayoutShellDialogHost = null;

        this.iconList = [
            <FiHeart />,
            <FiLoader />,
            <FiAlignJustify />,
            <FiBook />,
            <FiBookOpen />,
            <FiBriefcase />,
            <FiAward />,
            <FiZap />,
            <FiBox />,
            <FiThumbsUp />,
        ];

        this.state = {
            currentScreen: this.screens.Intro,

            isResumeSkipped: false,

            firstName: '',

            isStreamingComplete: false,
            isStreamingAnimationComplete: false,
            resumeParsingMessages: [],
            // resumeParsingMessages: ['message 1', 'message 2', 'message 3', 'message 4', 'message 5', 'message 6', 'message 7', 'message 8', 'message 9', 'message 10'],
            isProcessingResume: false,

            errorText: '',
        };
    };

    async componentDidMount() {
        if (!utils.isLoggedIn()) {
            window.location.href = '/signin';
            return;
        }

        if (!await this.hasUserCompletedOnboarding()) {
            this.connectWebSocket();
        }

        // this.temp = setInterval(() => {
        //     let msg = this.state.resumeParsingMessages;

        //     let str = '';
        //     for (let i = 0; i < Math.floor(Math.random() * 3) + 1; i++) {
        //         str += Math.random().toString(36).substring(2, 15) + ' ';
        //     }

        //     msg.push(str);

        //     this.setState({
        //         resumeParsingMessages: [...msg],
        //     })
        // }, 300);
    };

    componentWillUnmount() {
        if (this.socket) {
            this.socket.close();
        }

        // if (this.temp) {
        //     clearInterval(this.temp);
        // }
    };


    connectWebSocket = () => {
        this.socket = new WebSocket(utils.websocketHost());

        this.socket.onopen = () => {
            console.log('WebSocket connected');
        };

        this.socket.onmessage = (event) => {
            try {
                const message = JSON.parse(event.data);

                console.log('Received WebSocket message:', message);

                switch (message.type) {
                    case 'CONNECTED':
                        this.setState({
                            connectionId: message.connectionId
                        });
                        break;

                    case 'PROGRESS':
                        if (message.icon === 0) {
                            this.setState({
                                firstName: message.message.trim() || '',
                            });
                        }
                        else {
                            if (message.message && message.message.trim() !== '') {
                                this.setState({
                                    resumeParsingMessages: [...this.state.resumeParsingMessages, message],
                                    // status: message.step || 'PROCESSING',
                                    // progressMessage: message.message || '',
                                });
                            }
                        }
                        break;

                    case 'COMPLETE':
                        this.setState({
                            isStreamingComplete: true,
                        });

                        this.gotoDashboardOnComplete();
                        // this.setState({
                        //     status: 'COMPLETE',
                        //     // progressMessage: 'Resume successfully processed!',
                        //     // isProcessing: false,
                        // });
                        break;

                    default:
                        console.log('Received message:', message);
                }
            } catch (err) {
                console.error('Error parsing WebSocket message:', err);
            }
        };

        this.socket.onerror = (error) => console.error('WebSocket Error:', error);
        this.socket.onclose = () => {
            console.log('WebSocket disconnected');
        };
    };

    gotoDashboardOnComplete = () => {
        const {
            currentScreen,
            isStreamingComplete,
            isStreamingAnimationComplete,
        } = this.state;

        // COMPLETE event can get called at any time on any screen
        //  it depends on when backend finished processing resume.
        // So, we need to check if the user is on the FinishingUp screen
        //   CONTINUOUSLY checking the current screen before redirecting to the dashboard.

        if (currentScreen === this.screens.FinishingUp) {
            if (isStreamingComplete && isStreamingAnimationComplete) {
                setTimeout(() => {
                    window.location.href = '/dashboard';
                }, 3000);
            }
        }

        setTimeout(() => {
            this.gotoDashboardOnComplete();
        }, 500);

    };

    hasUserCompletedOnboarding = async () => {
        try {
            const response = await utils.sendRequest('/meta/getIsUserOnboarded', {});

            if (response && response.isOnboarded) {
                window.location.href = '/dashboard';
            }
        }
        catch (error) {
            console.log('onboarding status check error', error);
        }

        return false;
    };

    beginOnboarding = () => {
        this.setState({
            currentScreen: this.screens.Resume,
            errorText: '',
        });
    };

    getErrorMessage = (error, fallbackText) => {
        if (error && typeof error === 'object' && typeof error.message === 'string' && error.message.trim() !== '') {
            return error.message;
        }

        if (typeof error === 'string' && error.trim() !== '') {
            return error;
        }

        return fallbackText;
    };

    renderStepDots = () => {
        const {
            currentScreen
        } = this.state;

        if (
            currentScreen === this.screens.Intro ||
            currentScreen === this.screens.FinishingUp
        ) {
            return null;
        }

        return (
            <div className={styles.stepRow}>
                <div className={`${styles.stepDot} ${currentScreen >= this.screens.Resume ? styles.stepDotActive : ''}`} />
                <div className={styles.stepLine} />
                <div className={`${styles.stepDot} ${currentScreen >= this.screens.Nickname ? styles.stepDotActive : ''}`} />
                <div className={styles.stepLine} />
                <div className={`${styles.stepDot} ${currentScreen >= this.screens.Availability ? styles.stepDotActive : ''}`} />
                <div className={styles.stepLine} />
                <div className={`${styles.stepDot} ${currentScreen >= this.screens.Offers ? styles.stepDotActive : ''}`} />
            </div>
        );
    };

    renderIntroScreen = () => {
        return (
            <section className={`${styles.leftPanel} ${styles.centerPanel}`}>
                {/* <div className={styles.brandBadge}>HQVibe</div> */}
                <div className={styles.introPill}>Step 1 of 4</div>
                <h1 className={styles.title}>Set up HQ in a few quick steps.</h1>
                <p className={styles.subtitle}>
                    We use your resume and intent to match you with high-context opportunities and people worth knowing.
                </p>
                <button className={styles.primaryButton} type='button' onClick={this.beginOnboarding}>
                    Begin
                </button>
            </section>
        );
    };

    gotoNicknameScreen = () => {
        this.setState({
            currentScreen: this.screens.Nickname,
            errorText: '',
        });
    };

    skipResume = () => {
        this.setState({
            isResumeSkipped: true,
        }, this.gotoNicknameScreen);
    };

    gotoAvailabilityScreen = () => {
        this.setState({
            currentScreen: this.screens.Availability,
            errorText: '',
        });
    };

    gotoOffersScreen = () => {
        this.setState({
            currentScreen: this.screens.Offers,
            errorText: '',
        });
    };

    gotoFinishingUpScreen = () => {
        if (this.state.isResumeSkipped) {
            window.location.href = '/dashboard';
        }
        else {
            this.setState({
                currentScreen: this.screens.FinishingUp,
                errorText: '',
            });
        }
    };

    renderFinishingUpScreen = () => {
        const {
            resumeParsingMessages,
            firstName
        } = this.state;

        return (
            <section className={`${styles.leftPanel} ${styles.centerPanel}`}>
                <h2 className={styles.formTitle}>Setting things up...</h2>
                <p className={styles.formText}>We're auto-filling your profile with the interesting bits from your resume</p>
                {
                    firstName && firstName.trim() !== '' &&
                    <div className={styles.helloText}>Hello, {firstName}!</div>
                }

                <HQStreamerUtil
                    key='onboarding-streamer-util'
                    dataStream={resumeParsingMessages}
                    iconList={this.iconList}
                    isStreamingComplete={this.state.isStreamingComplete}
                    onCompleteAnimation={() => this.setState({ isStreamingAnimationComplete: true })}
                />
            </section>
        );
    };

    renderCurrentScreen = () => {
        const {
            currentScreen,
            availabilityItems,
            offerItems,
            isSavingAvailability,
            isSavingOffers,
        } = this.state;

        if (currentScreen === this.screens.Intro) {
            return this.renderIntroScreen();
        }
        else if (currentScreen === this.screens.Resume) {
            return (
                <OnboardingResume
                    connectionId={this.state.connectionId}
                    getDialogPortalNode={() => this.resumeLayoutShellDialogHost}
                    onContinue={this.gotoNicknameScreen}
                    // onContinue={this.gotoFinishingUpScreen}
                    onSkip={this.skipResume}
                />
            );
        }
        else if (currentScreen === this.screens.Nickname) {
            return (
                <OnboardingNickname
                    getDialogPortalNode={() => this.nicknameLayoutShellDialogHost}
                    onContinue={this.gotoAvailabilityScreen}
                />
            );
        }
        else if (currentScreen === this.screens.Availability) {
            return (
                <OnboardingAvailability
                    getDialogPortalNode={() => this.availabilityLayoutShellDialogHost}
                    onContinue={this.gotoOffersScreen}
                    onSkip={this.gotoOffersScreen}
                />
            );
        }
        else if (currentScreen === this.screens.Offers) {
            return (
                <OnboardingOffers
                    getDialogPortalNode={() => this.offersLayoutShellDialogHost}
                    onContinue={this.gotoFinishingUpScreen}
                    onSkip={this.gotoFinishingUpScreen}
                />
            );
        }
        else if (currentScreen === this.screens.FinishingUp) {
            return this.renderFinishingUpScreen();
        }
    };

    render() {
        const {
            currentScreen,
            errorText,
        } = this.state;

        return (
            <div className={styles.pageContainer}>
                <div className={styles.glowTop} />
                <div className={styles.glowBottom} />

                <div className={styles.layoutShell}>
                    <section className={styles.cardPanel}>
                        {this.renderStepDots()}

                        {this.renderCurrentScreen()}
                    </section>

                    {/* {this.renderSkipResumeDialog()} */}

                    <div ref={(node) => { this.nicknameLayoutShellDialogHost = node; }} />
                    <div ref={(node) => { this.resumeLayoutShellDialogHost = node; }} />
                    <div ref={(node) => { this.availabilityLayoutShellDialogHost = node; }} />
                    <div ref={(node) => { this.offersLayoutShellDialogHost = node; }} />
                </div>
            </div>
        );
    }
}
